module.exports = __webpack_public_path__ + "static/april-joyce-f6616fcf2e9d85ce878da5059fa26220.png";